export default "__VITE_ASSET__DWJPeONS__"